<template>
  <el-cascader
    style="width: 100%"
    clearable
    filterable
    :show-all-levels="showAllLevels"
    :placeholder="placeholder || '选择部门'"
    :options="organizationOptions"
    size="mini"
    :props="{
      label: 'organizationName',
      value: 'organizationId',
      children: 'children',
      multiple: true,
      ...props,
    }"
    :collapse-tags="collapseTags"
    :value="organization"
    @input="organization => $emit('input', organization)"
    @change="organization => $emit('change', organization)"
  ></el-cascader>
</template>

<script>
import Vue from 'vue';
// import http from '@/utils/request';
import { queryOrganizationTree } from '@/api/base';

export default Vue.extend({
  props: {
    value: [String, Number, Array],
    placeholder: String,
    props: Object,
    collapseTags: Boolean,
    showAllLevels: Boolean,
    type: String,
  },
  data() {
    return {
      organizationOptions: [],
      organization: '',
    };
  },
  watch: {
    value: {
      handler() {
        this.organization = this.value;
      },
      immediate: true,
    },
  },
  created() {
    this.getOrganizationTreeOptions();
  },
  methods: {
    clearChildren(child) {
      child.forEach((item) => {
        if (!item.children.length) {
          // eslint-disable-next-line no-param-reassign
          delete item.children;
        } else {
          this.clearChildren(item.children);
        }
      });
      return child;
    },
    async getOrganizationTreeOptions() {
      try {
        // const urls = {
        //   all: '/authManage/organization/tree',
        //   auth: '/authManage/manager/government/organization_tree',
        // };
        const { data: { organizationTreeVos } } = await queryOrganizationTree();
        // console.log(str);
        this.organizationOptions = this.clearChildren(organizationTreeVos);
      } catch (error) {
        console.error(error);
      }
    },
  },
});
</script>
